module.exports = __webpack_public_path__ + "static/media/checkoutTransactions.f49c7c70.svg";